/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-01-11 14:21:40
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import ProductItemForm from './product-item-form';
import ProductInformationForm from './product-information-form';
import ProductTitleForm from './product-title-form';
import ProductVendorForm from './product-vendor-form';
import ProductPriceForm from './product-price-form';
import InventoryStatusForm from './inventory-status-form';
import SwatchItemForm from './swatch-item-form';
import ProductImageForm from './product-image-form';
import ProductImageAreaForm from './product-image-area-form';
import QuickViewForm from './quick-view-form';
import AjaxCartForm from './ajax-cart-form';
import SoldOutLabelForm from './sold-out-label-form';
import CustomByTagLabelForm from './custom-by-tag-label-form';
import SaleLabelForm from './sale-label-form';
import ProductRatingForm from './product-rating-form';
import CollectionHeaderForm from './collection-header-form';
import CollectionHeaderImageForm from './collection-header-image-form';
import CollectionHeaderTitleForm from './collection-header-title-form';
import CollectionHeaderDescriptionForm from './collection-header-description-form';
import CollectionHeaderProductCountForm from './collection-header-product-count-form';
import CollectionHeaderBreadcrumbForm from './collection-header-breadcrumbs-form';
import ProductButtonForm from './product-button-form';
import ToolBarForm from './tool-bar-form';
import ToolBarViewAsForm from './tool-bar-view-as-form';
import ToolBarProductCountForm from './tool-bar-product-count-form';
import ToolBarSortByForm from './tool-bar-sort-by-form';
import ToolBarShowLimitForm from './tool-bar-show-limit-form';
import ProductListForm from './product-list-form';
import PaginationForm from './pagination-form';

import { ELEMENTS } from 'src/constants/theme-settings';
import { MENU_ID } from 'src/constants/theme-settings.jsx';

type Props = {
  activeMenuItem: string,
  formValues: any,
  filterDataOptions: any[],
  currentAppReviewIntegration: string,
  themeSettingDefaultValue: any,
  themeSettingDefaultThemeValue: any,
  labelTranslation: any,
  boostThemeLibName: string,
  updateField: (field: string, value: any) => void,
};

type ComposedProps = Props & WithI18nProps;

class GeneralForm extends Component<ComposedProps> {
  getSpecificForm = () => {
    const { activeMenuItem } = this.props;
    const MappingForm = {
      [MENU_ID.COLLECTION_HEADER]: CollectionHeaderForm,
      [ELEMENTS.COLLECTION_HEADER_IMAGE]: CollectionHeaderImageForm,
      [ELEMENTS.COLLECTION_HEADER_TITLE]: CollectionHeaderTitleForm,
      [ELEMENTS.COLLECTION_HEADER_DESCRIPTION]: CollectionHeaderDescriptionForm,
      [ELEMENTS.COLLECTION_HEADER_DESCRIPTION]: CollectionHeaderDescriptionForm,
      [ELEMENTS.COLLECTION_HEADER_PRODUCT_COUNT]: CollectionHeaderProductCountForm,
      [ELEMENTS.COLLECTION_HEADER_BREADCRUMBS]: CollectionHeaderBreadcrumbForm,
      [MENU_ID.TOOLBAR]: ToolBarForm,
      [ELEMENTS.TOOLBAR_VIEW_AS]: ToolBarViewAsForm,
      [ELEMENTS.TOOLBAR_PRODUCT_COUNT]: ToolBarProductCountForm,
      [ELEMENTS.TOOLBAR_SHOW_LIMIT]: ToolBarShowLimitForm,
      [ELEMENTS.TOOLBAR_SORT_BY]: ToolBarSortByForm,
      [MENU_ID.PAGINATION]: PaginationForm,
      [MENU_ID.PRODUCT_ITEM]: ProductItemForm,
      [MENU_ID.PRODUCT_LIST]: ProductListForm,
      [MENU_ID.PRODUCT_INFORMATION]: ProductInformationForm,
      [MENU_ID.PRODUCT_IMAGE]: ProductImageForm,
      [MENU_ID.PRODUCT_IMAGE_TOP]: ProductImageAreaForm,
      [MENU_ID.PRODUCT_IMAGE_MIDDLE]: ProductImageAreaForm,
      [MENU_ID.PRODUCT_IMAGE_BOTTOM]: ProductImageAreaForm,
      [ELEMENTS.PRODUCT_INFORMATION_PRODUCT_TITLE]: ProductTitleForm,
      [ELEMENTS.PRODUCT_INFORMATION_PRODUCT_VENDOR]: ProductVendorForm,
      [ELEMENTS.PRODUCT_INFORMATION_PRODUCT_PRICE]: ProductPriceForm,
      [ELEMENTS.PRODUCT_INFORMATION_INVENTORY_STATUS]: InventoryStatusForm,

      [ELEMENTS.PRODUCT_IMAGE_TOP_SWATCH_ITEM_1]: SwatchItemForm,
      [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SWATCH_ITEM_1]: SwatchItemForm,
      [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SWATCH_ITEM_1]: SwatchItemForm,
      [ELEMENTS.PRODUCT_IMAGE_TOP_SWATCH_ITEM_2]: SwatchItemForm,
      [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SWATCH_ITEM_2]: SwatchItemForm,
      [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SWATCH_ITEM_2]: SwatchItemForm,
      [ELEMENTS.PRODUCT_IMAGE_TOP_SWATCH_ITEM_3]: SwatchItemForm,
      [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SWATCH_ITEM_3]: SwatchItemForm,
      [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SWATCH_ITEM_3]: SwatchItemForm,
      [ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_1]: SwatchItemForm,
      [ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_2]: SwatchItemForm,
      [ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_3]: SwatchItemForm,
      [ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_3]: SwatchItemForm,
      [ELEMENTS.PRODUCT_INFORMATION_SWATCH_ITEM_3]: SwatchItemForm,

      [MENU_ID.QUICK_VIEW]: QuickViewForm,
      [MENU_ID.AJAX_CART]: AjaxCartForm,

      [ELEMENTS.PRODUCT_IMAGE_SOLD_OUT_LABEL]: SoldOutLabelForm,
      [ELEMENTS.PRODUCT_IMAGE_TOP_SOLD_OUT_LABEL]: SoldOutLabelForm,
      [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SOLD_OUT_LABEL]: SoldOutLabelForm,
      [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SOLD_OUT_LABEL]: SoldOutLabelForm,

      [ELEMENTS.PRODUCT_IMAGE_CUSTOM_BY_TAG_LABEL]: CustomByTagLabelForm,
      [ELEMENTS.PRODUCT_IMAGE_TOP_CUSTOM_BY_TAG_LABEL]: CustomByTagLabelForm,
      [ELEMENTS.PRODUCT_IMAGE_MIDDLE_CUSTOM_BY_TAG_LABEL]: CustomByTagLabelForm,
      [ELEMENTS.PRODUCT_IMAGE_BOTTOM_CUSTOM_BY_TAG_LABEL]: CustomByTagLabelForm,

      [ELEMENTS.PRODUCT_IMAGE_SALE_LABEL]: SaleLabelForm,
      [ELEMENTS.PRODUCT_IMAGE_TOP_SALE_LABEL]: SaleLabelForm,
      [ELEMENTS.PRODUCT_IMAGE_MIDDLE_SALE_LABEL]: SaleLabelForm,
      [ELEMENTS.PRODUCT_IMAGE_BOTTOM_SALE_LABEL]: SaleLabelForm,

      [ELEMENTS.PRODUCT_IMAGE_TOP_RATING]: ProductRatingForm,
      [ELEMENTS.PRODUCT_IMAGE_MIDDLE_RATING]: ProductRatingForm,
      [ELEMENTS.PRODUCT_IMAGE_BOTTOM_RATING]: ProductRatingForm,
      [ELEMENTS.PRODUCT_INFORMATION_RATING]: ProductRatingForm,

      [ELEMENTS.PRODUCT_INFORMATION_BUTTON_1]: ProductButtonForm,
      [ELEMENTS.PRODUCT_INFORMATION_BUTTON_2]: ProductButtonForm,
      [ELEMENTS.PRODUCT_IMAGE_TOP_BUTTON_1]: ProductButtonForm,
      [ELEMENTS.PRODUCT_IMAGE_MIDDLE_BUTTON_1]: ProductButtonForm,
      [ELEMENTS.PRODUCT_IMAGE_BOTTOM_BUTTON_1]: ProductButtonForm,
      [ELEMENTS.PRODUCT_IMAGE_TOP_BUTTON_2]: ProductButtonForm,
      [ELEMENTS.PRODUCT_IMAGE_MIDDLE_BUTTON_2]: ProductButtonForm,
      [ELEMENTS.PRODUCT_IMAGE_BOTTOM_BUTTON_2]: ProductButtonForm
    };

    return MappingForm[activeMenuItem];
  };

  render() {
    const {
      activeMenuItem,
      updateField,
      filterDataOptions,
      formValues,
      commonSetting,
      currentAppReviewIntegration,
      themeSettingDefaultValue,
      themeSettingDefaultThemeValue,
      labelTranslation,
      boostThemeLibName
    } = this.props;
    const SpecificForm = this.getSpecificForm();
    if (!SpecificForm) {
      return null;
    }

    return (
      <SpecificForm
        commonSetting={commonSetting}
        prefix={activeMenuItem}
        updateField={updateField}
        formValues={formValues}
        filterDataOptions={filterDataOptions} // For swatch item
        currentAppReviewIntegration={currentAppReviewIntegration} // For rating
        themeSettingDefaultValue={themeSettingDefaultValue}
        themeSettingDefaultThemeValue={themeSettingDefaultThemeValue}
        labelTranslation={labelTranslation} // For placeholder in form
        boostThemeLibName={boostThemeLibName} // For view as component options
      />
    );
  }
}

export default withI18n()(GeneralForm);
